import ModalSummarySection from "./ModalSummarySection";

export default ModalSummarySection;
